import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { PublicModule } from './public/public.module';
import { SecureModule } from './secure/secure.module';
import { authInterceptorProviders } from './_helpers/auth.interceptor';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
// Material Data tables
import { DatePipe } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetComponent } from './public/reset/reset.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { loaderInterceptorProviders } from './interceptors/loader.interceptor';
import { NzGridModule } from 'ng-zorro-antd/grid';

@NgModule({
  declarations: [AppComponent, ForgotPasswordComponent, ResetComponent],
  imports: [
    BrowserModule,
    SecureModule,
    ImageCropperModule,
    FontAwesomeModule,
    AppRoutingModule,
    PublicModule,
    RouterModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MomentDateModule,
    MomentDateModule,
    NzGridModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it' },
    authInterceptorProviders,
    loaderInterceptorProviders,
    DatePipe,
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
